import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotGardenComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotGarden',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    d: "M22 9.868c0-4.29-2.8-7.48-6.81-7.76-2.65-.18-4.56.31-5.83 1.5-1.07 1-1.61 2.43-1.61 4.27 0 .28.06.97.05 1.31l-.1 1.85c-.01.18-.23.26-.35.12l-1.51-1.69-.87-.98a.522.522 0 0 0-.39-.17l-1.22 3.075 3.76 7.155c.16.31.24.66.23 1.01l-.06 1.33c-.02.57.44 1.05 1.01 1.05h11.94c.64 0 1.12-.58.99-1.21l-1.14-4.76c-.07-.3.01-.62.2-.87 1.07-1.35 1.71-3.18 1.71-5.23Zm-10.92-4.42c.61-.57 1.64-.85 3.08-.85.27 0 .55.01.85.03 2.71.18 4.46 2.24 4.46 5.24 0 .73-.12 1.47-.35 2.15a5.034 5.034 0 0 0-4.84-3.68h-3.65c-.22 0-.36-.14-.35-.46 0-1.13.26-1.92.8-2.43Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#028C4A",
    d: "M5.89 9.558c.32-.72.21-1.61-.22-2.3-.06-.1-.2-.12-.3-.05 0 0-1.49.87-2.07 1.28-.58.42-1.57 1.24-2 1.69-.08.09-.11.21-.04.3.54.64 1.33.97 2.12.95.49-.29 2.09-1.51 2.51-1.87ZM15.69 10.728c0 .39-1.16.7-2.59.7s-2.52-.32-2.59-.7c-.14-.7 1.16-.7 2.59-.7s2.59-.01 2.59.7Z"
  }));
};
SpotGardenComponent.displayName = 'SpotGarden';
export var SpotGarden = withProvisionalOverrideFromContext(SpotGardenComponent);
//# sourceMappingURL=index.js.map